<!-- edit-menu.component.html -->
<div class="container">
  <div class="container-inventory">
    <div class="header">
      <h5 class="title">{{ 'EDIT_MENU' | translate }}</h5>
    </div>
    <form #myForm="ngForm">
        <div class="loading" *ngIf="loading">
          <div class="spinner-border" role="status"></div>
        </div>
      <div class="form-card"  *ngIf="!loading">
        <div class="col-md-5">
          <label class="form-label is-required" for="menu_name">{{'NAME' | translate}}</label>
          <div *ngIf="menu">
            <input type="text" class="form-control" id="menuName" placeholder="Nombre del menú" (keyup)="ChangeMenuName($event)"
            [(ngModel)]="menu.menuName" #menuName="ngModel" name="menuName" required/>
          </div>
        </div>
        <div class="input-container">
          <div>
            <a class="add-option-btn" (click)="addMenuOption()">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 56 56">
                <path fill="#6abdcc" d="M9.637 41.945h4.359v4.032c0 4.828 2.438 7.265 7.36 7.265h25.03c4.876 0 7.337-2.437 7.337-7.265V21.063c0-4.805-2.461-7.243-7.336-7.243h-4.36v-3.797c0-4.828-2.46-7.265-7.36-7.265H9.638c-4.899 0-7.36 2.437-7.36 7.265v24.68c0 4.828 2.461 7.242 7.36 7.242m.07-3.773c-2.344 0-3.656-1.242-3.656-3.68V10.234c0-2.437 1.312-3.703 3.656-3.703h24.914c2.297 0 3.633 1.266 3.633 3.703v3.586H21.356c-4.922 0-7.36 2.414-7.36 7.243v17.109Zm11.695 11.297c-2.343 0-3.633-1.266-3.633-3.703V21.273c0-2.437 1.29-3.68 3.633-3.68h24.914c2.32 0 3.633 1.243 3.633 3.68V45.79c0 2.414-1.312 3.68-3.633 3.68Zm12.516-6.188c.984 0 1.758-.797 1.758-1.851v-6.094h5.953c1.101 0 1.992-.844 1.992-1.852c0-.984-.89-1.828-1.992-1.828h-5.953v-6.07c0-1.055-.774-1.828-1.758-1.828s-1.781.773-1.781 1.828v6.07h-6.164c-.985 0-1.875.89-1.875 1.828c0 .985.89 1.852 1.875 1.852h6.164v6.094c0 1.054.797 1.851 1.78 1.851"/>
            </svg>
              <span class="create-text mx-2">{{ 'ADD_OPTION' | translate }}</span>
            </a>
          </div>
          <div *ngFor="let menuOption of menuOptions; let i = index" class="form-info">
              <div class="option-name">
                <div class="form-floating col-md-5">
                  <input type="text" class="form-control" id="option" placeholder="{{ 'OPTION_NAME' | translate }}"
                    [(ngModel)]="menuOption.optionName" name="optionName{{i}}" required>
                  <label for="option">{{ 'OPTION_NAME' | translate }}</label>
                </div>
                <div class="remove-button">
                  <a class="create-link" (click)="removeMenuOption(i)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24">
                      <path fill="#e11d48" d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6z"/>
                    </svg>
                  </a>
                </div>
              </div>
              <div class="radios-container">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions{{i}}" value="categories"
                      (change)="onOptionChange('categories', i)" [checked]="menuOption.optionType === 'categories'">
                    <label class="form-check-label" for="inlineRadioOptions{{i}}">{{'CATEGORY' | translate}}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="inlineRadioOptions{{i}}" name="inlineRadioOptions{{i}}"
                      value="subCategories" (change)="onOptionChange('subCategories', i)" [checked]="menuOption.optionType === 'subCategories'">
                    <label class="form-check-label" for="inlineRadioOptions{{i}}">{{'SUBCATEGORY' | translate}}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="inlineRadioOptions{{i}}" name="inlineRadioOptions{{i}}"
                      value="subSubcategories" (change)="onOptionChange('subSubcategories', i)" [checked]="menuOption.optionType === 'subSubcategories'">
                    <label class="form-check-label" for="inlineRadioOptions{{i}}">{{'SUB_SUBCATEGORY' | translate}}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions{{i}}" value="collections"
                      (change)="onOptionChange('collections', i)" [checked]="menuOption.optionType === 'collections'">
                    <label class="form-check-label" for="inlineRadioOptions{{i}}">{{'COLLECTIONS' | translate}}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions{{i}}" value="pages"
                    (change)="onOptionChange('pages', i)" [checked]="menuOption.optionType === 'pages'">
                    <label class="form-check-label" for="inlineRadioOptions{{i}}">{{'PAGES' | translate}}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions{{i}}" value="custom"
                      (change)="onOptionChange('custom', i)" [checked]="menuOption.optionType === 'custom'">
                    <label class="form-check-label" for="inlineRadioOptions{{i}}">{{'EXTERNAL_LINK' | translate}}</label>
                  </div>
                </div>
                <div class="select-container">
                 <div *ngIf="menuOption.optionType === 'categories'" class="form-floating col-md-5">
                  <select class="form-select" aria-label="Floating label select example" (change)="onCategoryChange($event, i)">
                    <option selected disabled>{{'SELECT_CATEGORY' | translate}}</option>
                    <option *ngFor="let category of categories" [value]="category.categoryId" [selected]="category.categoryId === menuOption.categoryId" >
                      {{ category.categoryName }}
                    </option>
                  </select>
                </div>
                <div *ngIf="menuOption.optionType === 'subCategories'" class="form-floating col-md-5">
                  <select class="form-select" aria-label="Floating label select example" (change)="onSubCategoryChange($event, i)">
                    <option selected disabled>{{'SELECT_SUBCATEGORY' | translate}}</option>
                    <option *ngFor="let subCategory of subCategories" [value]="subCategory.subCategoryId" [selected]="subCategory.subCategoryId === menuOption.subCategoryId" >
                      {{ subCategory.subCategoryName }}
                    </option>
                  </select>
                </div>
                <div *ngIf="menuOption.optionType === 'subSubcategories'" class="form-floating col-md-5">
                  <select class="form-select" aria-label="Floating label select example" (change)="onSubSubCategoryChange($event, i)">
                    <option selected disabled>{{'SELECT_SUB_SUBCATEGORY' | translate}}</option>
                    <option *ngFor="let subSubCategory of subSubCategories" [value]="subSubCategory.subSubCategoryId" [selected]="subSubCategory.subSubCategoryId === menuOption.subSubCategoryId" >
                      {{ subSubCategory.subSubCategoryName }}
                    </option>
                  </select>
                </div>
                <div *ngIf="menuOption.optionType === 'collections'" class="form-floating col-md-5">
                  <select class="form-select" aria-label="Floating label select example" (change)="onCollectionChange($event, i)">
                    <option selected disabled>{{'SELECT_COLLECTION' | translate}}</option>
                    <option *ngFor="let collection of collections" [value]="collection.collectionId" [selected]="collection.collectionId === menuOption.collectionId" >
                      {{ collection.collectionName }}
                    </option>
                  </select>
                </div>
                <div *ngIf="menuOption.optionType === 'custom'" class="form-floating col-md-5">
                  <input type="text"
                          class="form-control"
                          [ngClass]="{'is-invalid': menuOption.optionUrl && !isValidHttpUrl(menuOption.optionUrl)}"
                          id="optionUrl"
                          placeholder="{{ 'OPTION_URL' | translate }}"
                          [(ngModel)]="menuOption.optionUrl"
                          name="optionUrl{{i}}"
                          (change)="onUrlChange($event, i)">
                  <label for="optionUrl">{{ 'OPTION_URL' | translate }}</label>
                  <div class="invalid-feedback" *ngIf="menuOption.optionUrl && !isValidHttpUrl(menuOption.optionUrl)">
                    {{ 'INVALID_URL_FORMAT' | translate }}
                  </div>
                </div>
                
                <div *ngIf="menuOption.optionType === 'pages'" class="form-floating col-md-5">
                  <select class="form-select" aria-label="Floating label select example" (change)="onPageChange($event, i)">
                    <option selected disabled>{{'SELECT_PAGE' | translate}}</option>
                    <option *ngFor="let page of pages" [value]="page.pageId" [selected]="page.pageId === menuOption.pageId" >
                    {{ page.pageName }}
                    </option>
                  </select>
                  </div>
                </div>
                <!-- BOTÓN PARA AÑADIR SUB-OPCIÓN -->
                <div class="mt-2">
                  <a class="add-suboption-btn" (click)="addSubMenuOption(i)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 56 56">
                          <path fill="#61439a" d="M9.637 41.945h4.359v4.032c0 4.828 2.438 7.265 7.36 7.265h25.03c4.876 0 7.337-2.437 7.337-7.265V21.063c0-4.805-2.461-7.243-7.336-7.243h-4.36v-3.797c0-4.828-2.46-7.265-7.36-7.265H9.638c-4.899 0-7.36 2.437-7.36 7.265v24.68c0 4.828 2.461 7.242 7.36 7.242m.07-3.773c-2.344 0-3.656-1.242-3.656-3.68V10.234c0-2.437 1.312-3.703 3.656-3.703h24.914c2.297 0 3.633 1.266 3.633 3.703v3.586H21.356c-4.922 0-7.36 2.414-7.36 7.243v17.109Zm11.695 11.297c-2.343 0-3.633-1.266-3.633-3.703V21.273c0-2.437 1.29-3.68 3.633-3.68h24.914c2.32 0 3.633 1.243 3.633 3.68V45.79c0 2.414-1.312 3.68-3.633 3.68Zm12.516-6.188c.984 0 1.758-.797 1.758-1.851v-6.094h5.953c1.101 0 1.992-.844 1.992-1.852c0-.984-.89-1.828-1.992-1.828h-5.953v-6.07c0-1.055-.774-1.828-1.758-1.828s-1.781.773-1.781 1.828v6.07h-6.164c-.985 0-1.875.89-1.875 1.828c0 .985.89 1.852 1.875 1.852h6.164v6.094c0 1.054.797 1.851 1.78 1.851"/>
                        </svg>
                    <span class="create-text mx-2">{{ 'ADD_SUBOPTION' | translate }}</span>
                  </a>
                </div>

                <!-- LISTADO DE SUB-OPCIONES -->
                <div *ngIf="menuOption.children?.length"
                    class="ps-4 ms-2 mt-3 border-start border-2">
                  <div *ngFor="let child of menuOption.children; let j = index" class="form-info-suboption mb-3">

                    <div class="d-flex justify-content-between align-items-center">
                      <h6 class="mb-0">{{ 'SUBOPTION' | translate }} {{ j + 1 }}</h6>

                      <a class="cancel-link" (click)="removeSubMenuOption(i, j)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <path fill="#D44646"
                            d="M4 20h14v2H4a2 2 0 0 1-2-2V6h2zM20.22 2H7.78C6.8 2 6 2.8 6 3.78v12.44C6 17.2 6.8 18 7.78 18h12.44c.98 0 1.78-.8 1.78-1.78V3.78C22 2.8 21.2 2 20.22 2M19 13.6L17.6 15L14 11.4L10.4 15L9 13.6l3.6-3.6L9 6.4L10.4 5L14 8.6L17.6 5L19 6.4L15.4 10z" />
                        </svg>
                        <span class="create-text mx-2">{{ 'REMOVE_SUBOPTION' | translate }}</span>
                      </a>
                    </div>

                    <!-- NOMBRE -->
                    <div class="form-floating col-md-5 my-2">
                      <input type="text" class="form-control"
                            [(ngModel)]="child.optionName"
                            name="subOptionName{{i}}_{{j}}" placeholder="{{ 'SUBOPTION_NAME' | translate }}" required>
                      <label>{{ 'SUBOPTION_NAME' | translate }}</label>
                    </div>

                    <!-- TIPOS (radios) -->
                    <div class="radios-container">
                      <label class="form-check form-check-inline">
                        <input type="radio" class="form-check-input"
                              name="subType{{i}}_{{j}}" value="categories"
                              [(ngModel)]="child.optionType"> {{ 'CATEGORY' | translate }}
                      </label>
                      <label class="form-check form-check-inline">
                        <input type="radio" class="form-check-input"
                              name="subType{{i}}_{{j}}" value="subCategories"
                              [(ngModel)]="child.optionType"> {{ 'SUBCATEGORY' | translate }}
                      </label>
                      <label class="form-check form-check-inline">
                        <input type="radio" class="form-check-input"
                              name="subType{{i}}_{{j}}" value="subSubcategories"
                              [(ngModel)]="child.optionType"> {{ 'SUB_SUBCATEGORY' | translate }}
                      </label>
                      <label class="form-check form-check-inline">
                        <input type="radio" class="form-check-input"
                              name="subType{{i}}_{{j}}" value="collections"
                              [(ngModel)]="child.optionType"> {{ 'COLLECTIONS' | translate }}
                      </label>
                      <label class="form-check form-check-inline">
                        <input type="radio" class="form-check-input"
                              name="subType{{i}}_{{j}}" value="pages"
                              [(ngModel)]="child.optionType"> {{ 'PAGES' | translate }}
                      </label>
                      <label class="form-check form-check-inline">
                        <input type="radio" class="form-check-input"
                              name="subType{{i}}_{{j}}" value="custom"
                              [(ngModel)]="child.optionType"> {{ 'EXTERNAL_LINK' | translate }}
                      </label>
                    </div>

                    <!-- SELECTS / INPUTS según tipo -->
                    <div class="form-floating col-md-5 mt-2" *ngIf="child.optionType === 'categories'">
                      <select class="form-select"  #selectElement (change)="child.categoryId = selectElement.value">
                        <option disabled selected>{{ 'SELECT_CATEGORY' | translate }}</option>
                        <option *ngFor="let c of categories" [selected]="c.categoryId == child.categoryId"
                                [value]="c.categoryId">{{ c.categoryName }}</option>
                      </select>
                      <label>{{ 'CATEGORY' | translate }}</label>
                    </div>

                    <div class="form-floating col-md-5 mt-2" *ngIf="child.optionType === 'subCategories'">
                      <select class="form-select"  #selectElement (change)="child.subCategoryId  = selectElement.value">
                        <option disabled selected>{{ 'SELECT_SUBCATEGORY' | translate }}</option>
                        <option *ngFor="let s of subCategories" [selected]="s.subCategoryId == child.subCategoryId"
                                [value]="s.subCategoryId">{{ s.subCategoryName }}</option>
                      </select>
                      <label>{{ 'SUBCATEGORY' | translate }}</label>
                    </div>
                    <div class="form-floating col-md-5 mt-2" *ngIf="child.optionType === 'subSubcategories'">
                      <select class="form-select"  #selectElement (change)="child.subSubCategoryId = selectElement.value">
                        <option disabled selected>{{ 'SELECT_SUB_SUBCATEGORY' | translate }}</option>
                        <option *ngFor="let ss of subSubCategories" [selected]="ss.subSubCategoryId == child.subSubCategoryId"
                                [value]="ss.subSubCategoryId">{{ ss.subSubCategoryName }}</option>
                      </select>
                      <label>{{ 'SUB_SUBCATEGORY' | translate }}</label>
                    </div>
                    <div class="form-floating col-md-5 mt-2" *ngIf="child.optionType === 'collections'">
                      <select class="form-select"  #selectElement (change)="child.collectionId = selectElement.value">
                        <option disabled selected>{{ 'SELECT_COLLECTION' | translate }}</option>
                        <option *ngFor="let c of collections" [selected]="c.collectionId == child.collectionId"
                                [value]="c.collectionId">{{ c.collectionName }}</option>
                      </select>
                      <label>{{ 'COLLECTIONS' | translate }}</label>
                    </div>
                    <div class="form-floating col-md-5 mt-2" *ngIf="child.optionType === 'pages'">
                      <select class="form-select"  #selectElement (change)="child.pageId = selectElement.value">
                        <option disabled selected>{{ 'SELECT_PAGE' | translate }}</option>
                        <option *ngFor="let p of pages" [selected]="p.pageId == child.pageId"
                                [value]="p.pageId">{{ p.pageName }}</option>
                      </select>
                      <label>{{ 'PAGES' | translate }}</label>
                    </div>
                    <div class="form-floating col-md-5 mt-2" *ngIf="child.optionType === 'custom'">
                      <input type="text" class="form-control"
                            [ngClass]="{'is-invalid': child.optionUrl && !isValidHttpUrl(child.optionUrl)}"
                            [(ngModel)]="child.optionUrl"
                            name="subOptionUrl{{i}}_{{j}}"
                            placeholder="{{ 'OPTION_URL' | translate }}"
                            (change)="onSubUrlChange($event, i, j)">
                      <label>{{ 'OPTION_URL' | translate }}</label>
                      <div class="invalid-feedback" *ngIf="child.optionUrl && !isValidHttpUrl(child.optionUrl)">
                        {{ 'INVALID_URL_FORMAT' | translate }}
                      </div>
                    </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="form-buttons">
          <button type="submit" class="btn btn-outline-secondary submit-btn" (click)="validateFormData()">
            {{'SAVE_CHANGES' | translate}}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

  <div class="modal menu-confirm-modal fade" id="successMenuModal" tabindex="-1">
    <div class="modal-dialog menu-modal-dialog" role="document">
      <div class="modal-content menu-modal-content">
        <div class="modal-body menu-modal-body">
          <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
          <p class="text-center">{{ 'MENU_UPDATED_SUCCESS' | translate }}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal menu-confirm-modal fade" id="errorMenuModal" tabindex="-1">
    <div class="modal-dialog menu-modal-dialog" role="document">
      <div class="modal-content menu-modal-content">
        <div class="modal-body menu-modal-body">
          <h3 class="text-center">{{'ERROR' | translate}}</h3>
          <p class="text-center">{{'ERROR_SAVING_CHANGES' | translate}}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal menu-confirm-modal fade" id="requiredEditMenuModal" tabindex="-1">
    <div class="modal-dialog menu-modal-dialog" role="document">
      <div class="modal-content menu-modal-content">
        <div class="modal-body menu-modal-body">
          <h3 class="text-center">{{'ERROR' | translate}}</h3>
          <p class="text-center">{{'ALL_FIELDS_REQUIRED' | translate}}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal menu-confirm-modal fade" id="errorEditUrl" tabindex="-1">
    <div class="modal-dialog menu-modal-dialog" role="document">
      <div class="modal-content menu-modal-content">
        <div class="modal-body menu-modal-body">
          <h3 class="text-center">{{'ERROR' | translate}}</h3>
          <p class="text-center">{{ 'INVALID_URL' | translate }} {{ itemListId }}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
        </div>
      </div>
    </div>
  </div>